/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */
export const colourNeutral1 = 'rgb(var(--colour-neutral-1, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */
export const colourNeutral1Rgb = 'var(--colour-neutral-1, 255, 255, 255)';
/** css rgb function with reference to var, default value 245, 245, 245 (#f5f5f5) */
export const colourNeutral2 = 'rgb(var(--colour-neutral-2, 245, 245, 245))';
/** css var reference, default value 245, 245, 245 (#f5f5f5) */
export const colourNeutral2Rgb = 'var(--colour-neutral-2, 245, 245, 245)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */
export const colourNeutral3 = 'rgb(var(--colour-neutral-3, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */
export const colourNeutral3Rgb = 'var(--colour-neutral-3, 223, 223, 223)';
/** css rgb function with reference to var, default value 204, 204, 204 (#cccccc) */
export const colourNeutral4 = 'rgb(var(--colour-neutral-4, 204, 204, 204))';
/** css var reference, default value 204, 204, 204 (#cccccc) */
export const colourNeutral4Rgb = 'var(--colour-neutral-4, 204, 204, 204)';
/** css rgb function with reference to var, default value 146, 146, 146 (#929292) */
export const colourNeutral5 = 'rgb(var(--colour-neutral-5, 146, 146, 146))';
/** css var reference, default value 146, 146, 146 (#929292) */
export const colourNeutral5Rgb = 'var(--colour-neutral-5, 146, 146, 146)';
/** css rgb function with reference to var, default value 72, 72, 72 (#484848) */
export const colourNeutral6 = 'rgb(var(--colour-neutral-6, 72, 72, 72))';
/** css var reference, default value 72, 72, 72 (#484848) */
export const colourNeutral6Rgb = 'var(--colour-neutral-6, 72, 72, 72)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */
export const colourNeutral7 = 'rgb(var(--colour-neutral-7, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */
export const colourNeutral7Rgb = 'var(--colour-neutral-7, 17, 17, 17)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */
export const colourTextAndIcon1 = 'rgb(var(--colour-text-and-icon-1, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */
export const colourTextAndIcon1Rgb = 'var(--colour-text-and-icon-1, 17, 17, 17)';
/** css rgb function with reference to var, default value 72, 72, 72 (#484848) */
export const colourTextAndIcon2 = 'rgb(var(--colour-text-and-icon-2, 72, 72, 72))';
/** css var reference, default value 72, 72, 72 (#484848) */
export const colourTextAndIcon2Rgb = 'var(--colour-text-and-icon-2, 72, 72, 72)';
/** css rgb function with reference to var, default value 118, 118, 118 (#767676) */
export const colourTextAndIcon3 = 'rgb(var(--colour-text-and-icon-3, 118, 118, 118))';
/** css var reference, default value 118, 118, 118 (#767676) */
export const colourTextAndIcon3Rgb = 'var(--colour-text-and-icon-3, 118, 118, 118)';
/** css rgb function with reference to var, default value 146, 146, 146 (#929292) */
export const colourTextAndIcon4 = 'rgb(var(--colour-text-and-icon-4, 146, 146, 146))';
/** css var reference, default value 146, 146, 146 (#929292) */
export const colourTextAndIcon4Rgb = 'var(--colour-text-and-icon-4, 146, 146, 146)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */
export const colourTextAndIcon5 = 'rgb(var(--colour-text-and-icon-5, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */
export const colourTextAndIcon5Rgb = 'var(--colour-text-and-icon-5, 255, 255, 255)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */
export const colourElevation1 = 'rgb(var(--colour-elevation-1, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */
export const colourElevation1Rgb = 'var(--colour-elevation-1, 255, 255, 255)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */
export const colourElevation2 = 'rgb(var(--colour-elevation-2, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */
export const colourElevation2Rgb = 'var(--colour-elevation-2, 255, 255, 255)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */
export const colourElevation3 = 'rgb(var(--colour-elevation-3, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */
export const colourElevation3Rgb = 'var(--colour-elevation-3, 17, 17, 17)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */
export const colourElevation1Border = 'rgb(var(--colour-elevation-1-border, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */
export const colourElevation1BorderRgb = 'var(--colour-elevation-1-border, 223, 223, 223)';
/** css rgb function with reference to var, default value 72, 72, 72 (#484848) */
export const colourElevation2Border = 'rgb(var(--colour-elevation-2-border, 72, 72, 72))';
/** css var reference, default value 72, 72, 72 (#484848) */
export const colourElevation2BorderRgb = 'var(--colour-elevation-2-border, 72, 72, 72)';
/** css rgb function with reference to var, default value 0, 88, 163 (#0058a3) */
export const colourSemanticInformative = 'rgb(var(--colour-semantic-informative, 0, 88, 163))';
/** css var reference, default value 0, 88, 163 (#0058a3) */
export const colourSemanticInformativeRgb = 'var(--colour-semantic-informative, 0, 88, 163)';
/** css rgb function with reference to var, default value 10, 138, 0 (#0a8a00) */
export const colourSemanticPositive = 'rgb(var(--colour-semantic-positive, 10, 138, 0))';
/** css var reference, default value 10, 138, 0 (#0a8a00) */
export const colourSemanticPositiveRgb = 'var(--colour-semantic-positive, 10, 138, 0)';
/** css rgb function with reference to var, default value 242, 106, 47 (#f26a2f) */
export const colourSemanticCaution = 'rgb(var(--colour-semantic-caution, 242, 106, 47))';
/** css var reference, default value 242, 106, 47 (#f26a2f) */
export const colourSemanticCautionRgb = 'var(--colour-semantic-caution, 242, 106, 47)';
/** css rgb function with reference to var, default value 202, 80, 8 (#ca5008) */
export const colourSemanticCautionText = 'rgb(var(--colour-semantic-caution-text, 202, 80, 8))';
/** css var reference, default value 202, 80, 8 (#ca5008) */
export const colourSemanticCautionTextRgb = 'var(--colour-semantic-caution-text, 202, 80, 8)';
/** css rgb function with reference to var, default value 224, 7, 81 (#e00751) */
export const colourSemanticNegative = 'rgb(var(--colour-semantic-negative, 224, 7, 81))';
/** css var reference, default value 224, 7, 81 (#e00751) */
export const colourSemanticNegativeRgb = 'var(--colour-semantic-negative, 224, 7, 81)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */
export const colourStaticWhite = 'rgb(var(--colour-static-white, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */
export const colourStaticWhiteRgb = 'var(--colour-static-white, 255, 255, 255)';
/** css rgb function with reference to var, default value 245, 245, 245 (#f5f5f5) */
export const colourStaticLightGrey = 'rgb(var(--colour-static-light-grey, 245, 245, 245))';
/** css var reference, default value 245, 245, 245 (#f5f5f5) */
export const colourStaticLightGreyRgb = 'var(--colour-static-light-grey, 245, 245, 245)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */
export const colourStaticGrey = 'rgb(var(--colour-static-grey, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */
export const colourStaticGreyRgb = 'var(--colour-static-grey, 223, 223, 223)';
/** css rgb function with reference to var, default value 118, 118, 118 (#767676) */
export const colourStaticDarkGrey = 'rgb(var(--colour-static-dark-grey, 118, 118, 118))';
/** css var reference, default value 118, 118, 118 (#767676) */
export const colourStaticDarkGreyRgb = 'var(--colour-static-dark-grey, 118, 118, 118)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */
export const colourStaticBlack = 'rgb(var(--colour-static-black, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */
export const colourStaticBlackRgb = 'var(--colour-static-black, 17, 17, 17)';
/** css rgb function with reference to var, default value 0, 88, 163 (#0058a3) */
export const colourStaticIkeaBrandBlue = 'rgb(var(--colour-static-ikea-brand-blue, 0, 88, 163))';
/** css var reference, default value 0, 88, 163 (#0058a3) */
export const colourStaticIkeaBrandBlueRgb = 'var(--colour-static-ikea-brand-blue, 0, 88, 163)';
/** css rgb function with reference to var, default value 255, 219, 0 (#ffdb00) */
export const colourStaticIkeaBrandYellow = 'rgb(var(--colour-static-ikea-brand-yellow, 255, 219, 0))';
/** css var reference, default value 255, 219, 0 (#ffdb00) */
export const colourStaticIkeaBrandYellowRgb = 'var(--colour-static-ikea-brand-yellow, 255, 219, 0)';
/** css rgb function with reference to var, default value 0, 124, 193 (#007cc1) */
export const colourStaticIkeaFamily = 'rgb(var(--colour-static-ikea-family, 0, 124, 193))';
/** css var reference, default value 0, 124, 193 (#007cc1) */
export const colourStaticIkeaFamilyRgb = 'var(--colour-static-ikea-family, 0, 124, 193)';
/** css rgb function with reference to var, default value 222, 188, 156 (#debc9c) */
export const colourStaticIkeaBusinessNetwork = 'rgb(var(--colour-static-ikea-business-network, 222, 188, 156))';
/** css var reference, default value 222, 188, 156 (#debc9c) */
export const colourStaticIkeaBusinessNetworkRgb = 'var(--colour-static-ikea-business-network, 222, 188, 156)';
/** css rgb function with reference to var, default value 202, 80, 8 (#ca5008) */
export const colourCommercialMessageNew = 'rgb(var(--colour-commercial-message-new, 202, 80, 8))';
/** css var reference, default value 202, 80, 8 (#ca5008) */
export const colourCommercialMessageNewRgb = 'var(--colour-commercial-message-new, 202, 80, 8)';
/** css rgb function with reference to var, default value 204, 0, 8 (#cc0008) */
export const colourCommercialMessageNewLowerPrice = 'rgb(var(--colour-commercial-message-new-lower-price, 204, 0, 8))';
/** css var reference, default value 204, 0, 8 (#cc0008) */
export const colourCommercialMessageNewLowerPriceRgb = 'var(--colour-commercial-message-new-lower-price, 204, 0, 8)';
/** css rgb function with reference to var, default value 0, 124, 193 (#007cc1) */
export const colourCommercialMessageIkeaFamily = 'rgb(var(--colour-commercial-message-ikea-family, 0, 124, 193))';
/** css var reference, default value 0, 124, 193 (#007cc1) */
export const colourCommercialMessageIkeaFamilyRgb = 'var(--colour-commercial-message-ikea-family, 0, 124, 193)';
/** css rgb function with reference to var, default value 255, 219, 0 (#ffdb00) */
export const colourCommercialMessageBtiYellow = 'rgb(var(--colour-commercial-message-bti-yellow, 255, 219, 0))';
/** css var reference, default value 255, 219, 0 (#ffdb00) */
export const colourCommercialMessageBtiYellowRgb = 'var(--colour-commercial-message-bti-yellow, 255, 219, 0)';
/** css rgb function with reference to var, default value 204, 0, 8 (#cc0008) */
export const colourCommercialMessageBtiRed = 'rgb(var(--colour-commercial-message-bti-red, 204, 0, 8))';
/** css var reference, default value 204, 0, 8 (#cc0008) */
export const colourCommercialMessageBtiRedRgb = 'var(--colour-commercial-message-bti-red, 204, 0, 8)';
/** css rgb function with reference to var, default value 0, 133, 62 (#00853e) */
export const colourCampaignSustainability = 'rgb(var(--colour-campaign-sustainability, 0, 133, 62))';
/** css var reference, default value 0, 133, 62 (#00853e) */
export const colourCampaignSustainabilityRgb = 'var(--colour-campaign-sustainability, 0, 133, 62)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */
export const colourInteractivePrimaryBgDefault = 'rgb(var(--colour-interactive-primary-bg-default, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */
export const colourInteractivePrimaryBgDefaultRgb = 'var(--colour-interactive-primary-bg-default, 17, 17, 17)';
/** css rgb function with reference to var, default value 51, 51, 51 (#333333) */
export const colourInteractivePrimaryBgHover = 'rgb(var(--colour-interactive-primary-bg-hover, 51, 51, 51))';
/** css var reference, default value 51, 51, 51 (#333333) */
export const colourInteractivePrimaryBgHoverRgb = 'var(--colour-interactive-primary-bg-hover, 51, 51, 51)';
/** css rgb function with reference to var, default value 0, 0, 0 (#000000) */
export const colourInteractivePrimaryBgPressed = 'rgb(var(--colour-interactive-primary-bg-pressed, 0, 0, 0))';
/** css var reference, default value 0, 0, 0 (#000000) */
export const colourInteractivePrimaryBgPressedRgb = 'var(--colour-interactive-primary-bg-pressed, 0, 0, 0)';
/** css rgb function with reference to var, default value 245, 245, 245 (#f5f5f5) */
export const colourInteractiveSecondaryBgDefault = 'rgb(var(--colour-interactive-secondary-bg-default, 245, 245, 245))';
/** css var reference, default value 245, 245, 245 (#f5f5f5) */
export const colourInteractiveSecondaryBgDefaultRgb = 'var(--colour-interactive-secondary-bg-default, 245, 245, 245)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */
export const colourInteractiveSecondaryBgHover = 'rgb(var(--colour-interactive-secondary-bg-hover, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */
export const colourInteractiveSecondaryBgHoverRgb = 'var(--colour-interactive-secondary-bg-hover, 223, 223, 223)';
/** css rgb function with reference to var, default value 204, 204, 204 (#cccccc) */
export const colourInteractiveSecondaryBgPressed = 'rgb(var(--colour-interactive-secondary-bg-pressed, 204, 204, 204))';
/** css var reference, default value 204, 204, 204 (#cccccc) */
export const colourInteractiveSecondaryBgPressedRgb = 'var(--colour-interactive-secondary-bg-pressed, 204, 204, 204)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */
export const colourInteractiveSubtleBgDefault = 'rgb(var(--colour-interactive-subtle-bg-default, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */
export const colourInteractiveSubtleBgDefaultRgb = 'var(--colour-interactive-subtle-bg-default, 255, 255, 255)';
/** css rgb function with reference to var, default value 245, 245, 245 (#f5f5f5) */
export const colourInteractiveSubtleBgHover = 'rgb(var(--colour-interactive-subtle-bg-hover, 245, 245, 245))';
/** css var reference, default value 245, 245, 245 (#f5f5f5) */
export const colourInteractiveSubtleBgHoverRgb = 'var(--colour-interactive-subtle-bg-hover, 245, 245, 245)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */
export const colourInteractiveSubtleBgPressed = 'rgb(var(--colour-interactive-subtle-bg-pressed, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */
export const colourInteractiveSubtleBgPressedRgb = 'var(--colour-interactive-subtle-bg-pressed, 223, 223, 223)';
/** css rgb function with reference to var, default value 146, 146, 146 (#929292) */
export const colourInteractiveSubtleBorderDefault = 'rgb(var(--colour-interactive-subtle-border-default, 146, 146, 146))';
/** css var reference, default value 146, 146, 146 (#929292) */
export const colourInteractiveSubtleBorderDefaultRgb = 'var(--colour-interactive-subtle-border-default, 146, 146, 146)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */
export const colourInteractiveSubtleBorderHover = 'rgb(var(--colour-interactive-subtle-border-hover, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */
export const colourInteractiveSubtleBorderHoverRgb = 'var(--colour-interactive-subtle-border-hover, 17, 17, 17)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */
export const colourInteractiveSubtleBorderPressed = 'rgb(var(--colour-interactive-subtle-border-pressed, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */
export const colourInteractiveSubtleBorderPressedRgb = 'var(--colour-interactive-subtle-border-pressed, 17, 17, 17)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */
export const colourInteractiveSubtleBorderSelected = 'rgb(var(--colour-interactive-subtle-border-selected, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */
export const colourInteractiveSubtleBorderSelectedRgb = 'var(--colour-interactive-subtle-border-selected, 17, 17, 17)';
/** css rgb function with reference to var, default value 0, 88, 163 (#0058a3) */
export const colourInteractiveEmphasisedBgDefault = 'rgb(var(--colour-interactive-emphasised-bg-default, 0, 88, 163))';
/** css var reference, default value 0, 88, 163 (#0058a3) */
export const colourInteractiveEmphasisedBgDefaultRgb = 'var(--colour-interactive-emphasised-bg-default, 0, 88, 163)';
/** css rgb function with reference to var, default value 0, 79, 147 (#004f93) */
export const colourInteractiveEmphasisedBgHover = 'rgb(var(--colour-interactive-emphasised-bg-hover, 0, 79, 147))';
/** css var reference, default value 0, 79, 147 (#004f93) */
export const colourInteractiveEmphasisedBgHoverRgb = 'var(--colour-interactive-emphasised-bg-hover, 0, 79, 147)';
/** css rgb function with reference to var, default value 0, 62, 114 (#003e72) */
export const colourInteractiveEmphasisedBgPressed = 'rgb(var(--colour-interactive-emphasised-bg-pressed, 0, 62, 114))';
/** css var reference, default value 0, 62, 114 (#003e72) */
export const colourInteractiveEmphasisedBgPressedRgb = 'var(--colour-interactive-emphasised-bg-pressed, 0, 62, 114)';
/** css rgb function with reference to var, default value 0, 88, 163 (#0058a3) */
export const colourInteractiveEmphasisedBorderSelected = 'rgb(var(--colour-interactive-emphasised-border-selected, 0, 88, 163))';
/** css var reference, default value 0, 88, 163 (#0058a3) */
export const colourInteractiveEmphasisedBorderSelectedRgb = 'var(--colour-interactive-emphasised-border-selected, 0, 88, 163)';
/** css rgb function with reference to var, default value 224, 7, 81 (#e00751) */
export const colourInteractiveDestructiveBgDefault = 'rgb(var(--colour-interactive-destructive-bg-default, 224, 7, 81))';
/** css var reference, default value 224, 7, 81 (#e00751) */
export const colourInteractiveDestructiveBgDefaultRgb = 'var(--colour-interactive-destructive-bg-default, 224, 7, 81)';
/** css rgb function with reference to var, default value 204, 0, 61 (#cc003d) */
export const colourInteractiveDestructiveBgHover = 'rgb(var(--colour-interactive-destructive-bg-hover, 204, 0, 61))';
/** css var reference, default value 204, 0, 61 (#cc003d) */
export const colourInteractiveDestructiveBgHoverRgb = 'var(--colour-interactive-destructive-bg-hover, 204, 0, 61)';
/** css rgb function with reference to var, default value 184, 0, 41 (#b80029) */
export const colourInteractiveDestructiveBgPressed = 'rgb(var(--colour-interactive-destructive-bg-pressed, 184, 0, 41))';
/** css var reference, default value 184, 0, 41 (#b80029) */
export const colourInteractiveDestructiveBgPressedRgb = 'var(--colour-interactive-destructive-bg-pressed, 184, 0, 41)';
/** css rgb function with reference to var, default value 204, 204, 204 (#cccccc) */
export const colourInteractiveDisabled1 = 'rgb(var(--colour-interactive-disabled-1, 204, 204, 204))';
/** css var reference, default value 204, 204, 204 (#cccccc) */
export const colourInteractiveDisabled1Rgb = 'var(--colour-interactive-disabled-1, 204, 204, 204)';
/** css rgb function with reference to var, default value 146, 146, 146 (#929292) */
export const colourInteractiveDisabled2 = 'rgb(var(--colour-interactive-disabled-2, 146, 146, 146))';
/** css var reference, default value 146, 146, 146 (#929292) */
export const colourInteractiveDisabled2Rgb = 'var(--colour-interactive-disabled-2, 146, 146, 146)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */
export const colourInteractiveDisabled3 = 'rgb(var(--colour-interactive-disabled-3, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */
export const colourInteractiveDisabled3Rgb = 'var(--colour-interactive-disabled-3, 255, 255, 255)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */
export const colourInteractiveStaticPrimaryBgDefault = 'rgb(var(--colour-interactive-static-primary-bg-default, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */
export const colourInteractiveStaticPrimaryBgDefaultRgb = 'var(--colour-interactive-static-primary-bg-default, 17, 17, 17)';
/** css rgb function with reference to var, default value 51, 51, 51 (#333333) */
export const colourInteractiveStaticPrimaryBgHover = 'rgb(var(--colour-interactive-static-primary-bg-hover, 51, 51, 51))';
/** css var reference, default value 51, 51, 51 (#333333) */
export const colourInteractiveStaticPrimaryBgHoverRgb = 'var(--colour-interactive-static-primary-bg-hover, 51, 51, 51)';
/** css rgb function with reference to var, default value 245, 245, 245 (#f5f5f5) */
export const colourInteractiveStaticSecondaryBgDefault = 'rgb(var(--colour-interactive-static-secondary-bg-default, 245, 245, 245))';
/** css var reference, default value 245, 245, 245 (#f5f5f5) */
export const colourInteractiveStaticSecondaryBgDefaultRgb = 'var(--colour-interactive-static-secondary-bg-default, 245, 245, 245)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */
export const colourInteractiveStaticSecondaryBgHover = 'rgb(var(--colour-interactive-static-secondary-bg-hover, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */
export const colourInteractiveStaticSecondaryBgHoverRgb = 'var(--colour-interactive-static-secondary-bg-hover, 223, 223, 223)';
/** css rgb function with reference to var, default value 204, 204, 204 (#cccccc) */
export const colourInteractiveStaticSecondaryBgPressed = 'rgb(var(--colour-interactive-static-secondary-bg-pressed, 204, 204, 204))';
/** css var reference, default value 204, 204, 204 (#cccccc) */
export const colourInteractiveStaticSecondaryBgPressedRgb = 'var(--colour-interactive-static-secondary-bg-pressed, 204, 204, 204)';
/** css rgb function with reference to var, default value 0, 0, 0 (#000000) */
export const colourInteractiveStaticPrimaryBgPressed = 'rgb(var(--colour-interactive-static-primary-bg-pressed, 0, 0, 0))';
/** css var reference, default value 0, 0, 0 (#000000) */
export const colourInteractiveStaticPrimaryBgPressedRgb = 'var(--colour-interactive-static-primary-bg-pressed, 0, 0, 0)';
export default {
    colourNeutral1,
    colourNeutral1Rgb,
    colourNeutral2,
    colourNeutral2Rgb,
    colourNeutral3,
    colourNeutral3Rgb,
    colourNeutral4,
    colourNeutral4Rgb,
    colourNeutral5,
    colourNeutral5Rgb,
    colourNeutral6,
    colourNeutral6Rgb,
    colourNeutral7,
    colourNeutral7Rgb,
    colourTextAndIcon1,
    colourTextAndIcon1Rgb,
    colourTextAndIcon2,
    colourTextAndIcon2Rgb,
    colourTextAndIcon3,
    colourTextAndIcon3Rgb,
    colourTextAndIcon4,
    colourTextAndIcon4Rgb,
    colourTextAndIcon5,
    colourTextAndIcon5Rgb,
    colourElevation1,
    colourElevation1Rgb,
    colourElevation2,
    colourElevation2Rgb,
    colourElevation3,
    colourElevation3Rgb,
    colourElevation1Border,
    colourElevation1BorderRgb,
    colourElevation2Border,
    colourElevation2BorderRgb,
    colourSemanticInformative,
    colourSemanticInformativeRgb,
    colourSemanticPositive,
    colourSemanticPositiveRgb,
    colourSemanticCaution,
    colourSemanticCautionRgb,
    colourSemanticCautionText,
    colourSemanticCautionTextRgb,
    colourSemanticNegative,
    colourSemanticNegativeRgb,
    colourStaticWhite,
    colourStaticWhiteRgb,
    colourStaticLightGrey,
    colourStaticLightGreyRgb,
    colourStaticGrey,
    colourStaticGreyRgb,
    colourStaticDarkGrey,
    colourStaticDarkGreyRgb,
    colourStaticBlack,
    colourStaticBlackRgb,
    colourStaticIkeaBrandBlue,
    colourStaticIkeaBrandBlueRgb,
    colourStaticIkeaBrandYellow,
    colourStaticIkeaBrandYellowRgb,
    colourStaticIkeaFamily,
    colourStaticIkeaFamilyRgb,
    colourStaticIkeaBusinessNetwork,
    colourStaticIkeaBusinessNetworkRgb,
    colourCommercialMessageNew,
    colourCommercialMessageNewRgb,
    colourCommercialMessageNewLowerPrice,
    colourCommercialMessageNewLowerPriceRgb,
    colourCommercialMessageIkeaFamily,
    colourCommercialMessageIkeaFamilyRgb,
    colourCommercialMessageBtiYellow,
    colourCommercialMessageBtiYellowRgb,
    colourCommercialMessageBtiRed,
    colourCommercialMessageBtiRedRgb,
    colourCampaignSustainability,
    colourCampaignSustainabilityRgb,
    colourInteractivePrimaryBgDefault,
    colourInteractivePrimaryBgDefaultRgb,
    colourInteractivePrimaryBgHover,
    colourInteractivePrimaryBgHoverRgb,
    colourInteractivePrimaryBgPressed,
    colourInteractivePrimaryBgPressedRgb,
    colourInteractiveSecondaryBgDefault,
    colourInteractiveSecondaryBgDefaultRgb,
    colourInteractiveSecondaryBgHover,
    colourInteractiveSecondaryBgHoverRgb,
    colourInteractiveSecondaryBgPressed,
    colourInteractiveSecondaryBgPressedRgb,
    colourInteractiveSubtleBgDefault,
    colourInteractiveSubtleBgDefaultRgb,
    colourInteractiveSubtleBgHover,
    colourInteractiveSubtleBgHoverRgb,
    colourInteractiveSubtleBgPressed,
    colourInteractiveSubtleBgPressedRgb,
    colourInteractiveSubtleBorderDefault,
    colourInteractiveSubtleBorderDefaultRgb,
    colourInteractiveSubtleBorderHover,
    colourInteractiveSubtleBorderHoverRgb,
    colourInteractiveSubtleBorderPressed,
    colourInteractiveSubtleBorderPressedRgb,
    colourInteractiveSubtleBorderSelected,
    colourInteractiveSubtleBorderSelectedRgb,
    colourInteractiveEmphasisedBgDefault,
    colourInteractiveEmphasisedBgDefaultRgb,
    colourInteractiveEmphasisedBgHover,
    colourInteractiveEmphasisedBgHoverRgb,
    colourInteractiveEmphasisedBgPressed,
    colourInteractiveEmphasisedBgPressedRgb,
    colourInteractiveEmphasisedBorderSelected,
    colourInteractiveEmphasisedBorderSelectedRgb,
    colourInteractiveDestructiveBgDefault,
    colourInteractiveDestructiveBgDefaultRgb,
    colourInteractiveDestructiveBgHover,
    colourInteractiveDestructiveBgHoverRgb,
    colourInteractiveDestructiveBgPressed,
    colourInteractiveDestructiveBgPressedRgb,
    colourInteractiveDisabled1,
    colourInteractiveDisabled1Rgb,
    colourInteractiveDisabled2,
    colourInteractiveDisabled2Rgb,
    colourInteractiveDisabled3,
    colourInteractiveDisabled3Rgb,
    colourInteractiveStaticPrimaryBgDefault,
    colourInteractiveStaticPrimaryBgDefaultRgb,
    colourInteractiveStaticPrimaryBgHover,
    colourInteractiveStaticPrimaryBgHoverRgb,
    colourInteractiveStaticSecondaryBgDefault,
    colourInteractiveStaticSecondaryBgDefaultRgb,
    colourInteractiveStaticSecondaryBgHover,
    colourInteractiveStaticSecondaryBgHoverRgb,
    colourInteractiveStaticSecondaryBgPressed,
    colourInteractiveStaticSecondaryBgPressedRgb,
    colourInteractiveStaticPrimaryBgPressed,
    colourInteractiveStaticPrimaryBgPressedRgb,
};
